import React from "react";
import { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import FooterLogo from "../../assets/images/code-infoway-white-logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faInstagram,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

export const FooterRow = () => {
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    // Update the year when the component mounts
    setYear(new Date().getFullYear());
  }, []);

  return (
    <React.Fragment>
      <div>
        <Container>
          <div className="row">
            <div className="col-lg-3">
              <img src={FooterLogo} alt="Footer Logo" className="footer-logo" />
              <p>
                407, Gravity Retail & Work Spaces, MG Road, Nikol, Ahmedabad,
                Gujarat 380038
              </p>
              <Link to="mailto:contact@codeinfoway.com">
                contact@codeinfoway.com
              </Link>
              <Link to="tel:+91 9016501095">+91 9016501095</Link>
            </div>
            <div className="col-lg-3">
              <h3>Quick Links</h3>
              <ul className="footer-menu">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>
                  <Link to="/about-us">About Us</Link>
                </li>
                <li>
                  <Link to="/portfolio">Portfolio</Link>
                </li>
                <li>
                  <Link to="/blog">Blogs</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3">
              <h3>Services</h3>
              <ul className="footer-menu">
                <li>
                  <Link to="/react-native">React Native</Link>
                </li>
                <li>
                  <Link to="/ios">IOS</Link>
                </li>
                <li>
                  <Link to="/android">Android</Link>
                </li>
                <li>
                  <Link to="/ipad-tablet">iPad & Tablet</Link>
                </li>
                <li>
                  <Link to="/flutter">Flutter</Link>
                </li>
              </ul>
            </div>
            <div className="col-lg-3">
              <h3>Follow Us</h3>
              <ul className="social-media">
                <li>
                  <Link to="https://www.facebook.com/profile.php?id=61570993910963">
                    <FontAwesomeIcon icon={faFacebookF} />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.linkedin.com/company/codeinfoway/">
                    <FontAwesomeIcon icon={faLinkedinIn} />
                  </Link>
                </li>
                <li>
                  <Link to="">
                    <FontAwesomeIcon icon={faInstagram} />
                  </Link>
                </li>
                <li>
                  <Link to="https://www.youtube.com/channel/UCdpm8DEMicNuL-ssjQfqEPA">
                    <FontAwesomeIcon icon={faYoutube} />
                  </Link>
                </li>
              </ul>
            </div>
          </div>
          <div className="row pt-3 mt-3">
            <div className="col-lg-12">
              <p className="text-white text-center mb-0">
                {`Copyright © ${year}. All Rights Reserved`}
              </p>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};
